import { render, staticRenderFns } from "./SingleStepTeam.vue?vue&type=template&id=42b7bdf2&scoped=true"
import script from "./SingleStepTeam.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleStepTeam.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SingleStepTeam.vue?vue&type=style&index=0&id=42b7bdf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b7bdf2",
  null
  
)

export default component.exports